module.exports = __webpack_public_path__ + "media/application/images/icons/wiki-third-level-branch-e79965974b98661fd6688b7a37926ec1.svg";